import React, { createContext, useState } from 'react';

const ContentBlocksContext = createContext({
  contentBlocks: [],
  setContentBlocks: (contentBlocks) => {},
});

export function ContentBlocksContextProvider(props) {
  const [contentBlocks, setContentBlocks] = useState([]);

  const context = {
    contentBlocks: contentBlocks,
    setContentBlocks: setContentBlocks,
  };

  return (
    <ContentBlocksContext.Provider value={context}>
      {props.children}
    </ContentBlocksContext.Provider>
  );
}

export default ContentBlocksContext;
